<template>
  <v-row no-gutters class="fill-height">
    <v-col class="d-flex flex-column align-stretch">
      <theHeading />
    </v-col>
  </v-row>
</template>

<script>
import theHeading from "@/layouts/intranet/components/viewHeading.vue"

export default {
  components: {
    theHeading,
  },
}
</script>

<style lang="scss" scoped></style>
